import { renderMarkdown } from "../shared/markdown";
import { t } from "./i18n";

const PRINT_STYLE = `
  body { font: 12pt/1.45 Georgia, "Times New Roman", serif; color: #111; margin: 24px; }
  h1,h2,h3,h4 { font-family: Georgia, serif; line-height: 1.2; margin: 1.2em 0 0.4em; }
  h1 { font-size: 22pt; } h2 { font-size: 16pt; } h3 { font-size: 13pt; }
  p, li { margin: 0.4em 0; }
  code, pre { font-family: Consolas, monospace; font-size: 10pt; }
  pre { background: #f4f4f4; padding: 10px; white-space: pre-wrap; }
  blockquote { border-left: 3px solid #999; margin: 0.8em 0; padding-left: 12px; color: #444; }
  a { color: #0645ad; }
  hr { border: none; border-top: 1px solid #ccc; margin: 1.2em 0; }
  @page { margin: 16mm; }
`;

export function printMarkdown(title: string, markdown: string): void {
  const frame = document.createElement("iframe");
  frame.setAttribute("aria-hidden", "true");
  frame.style.position = "fixed";
  frame.style.right = "0";
  frame.style.bottom = "0";
  frame.style.width = "0";
  frame.style.height = "0";
  frame.style.border = "0";
  document.body.append(frame);
  const doc = frame.contentDocument;
  if (!doc) {
    frame.remove();
    throw new Error(t("could not open a print sheet"));
  }
  doc.open();
  doc.write(`<!doctype html><html><head><title>${escapeAttr(title)}</title><style>${PRINT_STYLE}</style></head><body><h1>${escapeAttr(title)}</h1>${renderMarkdown(markdown)}</body></html>`);
  doc.close();
  const finish = () => {
    window.setTimeout(() => frame.remove(), 800);
  };
  frame.onload = () => {
    try {
      frame.contentWindow?.focus();
      frame.contentWindow?.print();
    } finally {
      finish();
    }
  };
  window.setTimeout(() => {
    try {
      frame.contentWindow?.focus();
      frame.contentWindow?.print();
    } finally {
      finish();
    }
  }, 250);
}

function escapeAttr(text: string): string {
  return String(text || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/"/g, "&quot;");
}
